import React from "react";

/** DOMO wordmark. Text-based so it stays crisp at any size and inherits color. */
export default function Wordmark({ size = 1, sub = true }) {
  return (
    <span className="wm" style={{ fontSize: `${size}rem` }}>
      <span className="wm-en">D<span className="wm-o">Ō</span>MO</span>
      {sub && <span className="wm-sub">Japanese Country Foods</span>}
      <style dangerouslySetInnerHTML={{ __html: `
        .wm { display: inline-flex; flex-direction: column; line-height: 1; }
        .wm-en { font-family: var(--serif); font-weight: 700; font-size: 1.7em; letter-spacing: .12em; }
        .wm-o { color: var(--shu-2); }
        .wm-sub { font-family: var(--sans); font-size: .5em; letter-spacing: .3em; text-transform: uppercase; margin-top: .45em; opacity: .8; font-weight: 500; }
      ` }} />
    </span>
  );
}
